<template>
  <v-sheet>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="2">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            outlined
            dense
            clearable
            single-line
            hide-details
            class="ma-2"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-sheet outlined style="min-height: 200px; max-height: 800px; overflow-y: auto;">
      <v-data-table
          :headers="dynamicHeaders"
          :items="tdata"
          :search="search"
          dense
          fixed-header
          class="sticky-table"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :custom-sort="customSort"
          @update:sort-by="handleSortByUpdate"
          no-data-text="No results available. Please initiate a search by selecting 'Search Items' to navigate the database."
          no-results-text="No results found for the current search terms. Please try different keywords."
      >

        <template v-slot:header.sentence_based_summary>
          <span class="d-flex align-center">
            GPT Sentence Summary
            <helpicon tooltip-text="Summary generated by GPT model based on textmining sentences." class="ml-1" />
          </span>
        </template>

        <template v-slot:item.sentence_based_summary="{ item,idx }">
          <div class="summary-col-1">
            <span v-if="item.sentence_based_summary && item.sentence_based_summary.toLowerCase() !== 'none'">
              <span v-if="!isExpanded(item.id)">
                {{ item.sentence_based_summary.slice(0, 300) }}<span v-if="item.sentence_based_summary.length > 300">... <a @click="toggleExpanded(item.id)">more</a></span>
              </span>
              <span v-else>
                {{ item.sentence_based_summary }} <a @click="toggleExpanded(item.id)">less</a>
              </span>
            </span>
            <span v-else>None</span>
          </div>
        </template>

<!--        <template v-slot:header.knowledge_based_summary>-->
<!--          <span class="d-flex align-center">-->
<!--            GPT Knowledge Summary-->
<!--            <helpicon tooltip-text="Summary based on structured biomedical knowledge." class="ml-1" />-->
<!--          </span>-->
<!--        </template>-->

<!--        <template v-slot:item.knowledge_based_summary="{ item }">-->
<!--          <div class="summary-col-2">-->
<!--            <span v-if="item.knowledge_based_summary && item.knowledge_based_summary.toLowerCase() !== 'none'">-->
<!--              <span v-if="!isExpanded('k_' + item.id)">-->
<!--                {{ item.knowledge_based_summary.slice(0, 100) }}<span v-if="item.knowledge_based_summary.length > 100">... <a @click="toggleExpanded('k_' + item.id)">more</a></span>-->
<!--              </span>-->
<!--              <span v-else>-->
<!--                {{ item.knowledge_based_summary }} <a @click="toggleExpanded('k_' + item.id)">less</a>-->
<!--              </span>-->
<!--            </span>-->
<!--            <span v-else>None</span>-->
<!--          </div>-->
<!--        </template>-->

        <template v-slot:item.id="{ item }">
          <router-link :to="`/single-search/${item.internal_id}?ptm_type=${encodeURIComponent(item.ptm_type)}`" target="_blank">
            {{ item.id }}
          </router-link>
        </template>

<!--        <template v-slot:item.harm_protein="{ item }">-->
<!--          <span>{{ item.harm_protein }}</span>-->
<!--        </template>-->

<!--        <template v-slot:item.ptm_type="{ item }">-->
<!--          <span>{{ item.ptm_type === 'phosphorylation' ? 'p' : $mycommon.capitalizeFirstLetter(item.ptm_type) }}</span>-->
<!--        </template>-->
        <template v-slot:item.publication_score_norm="{ item }">
          <span>{{ isFinite(Number(item.publication_score_norm)) ? Number(item.publication_score_norm).toFixed(3) : '-' }}</span>
        </template>

        <template v-slot:item.data_score_norm="{ item }">
          <span>{{ isFinite(Number(item.data_score_norm)) ? Number(item.data_score_norm).toFixed(3) : '-' }}</span>
        </template>
        <template v-slot:item.user_input_score="{ item }">
          <span>{{ isFinite(Number(item.user_input_score)) ? Number(item.user_input_score).toFixed(3) : '-' }}</span>
        </template>

        <template v-slot:item.text_evidence_count="{ item }">
          <v-chip
              v-if="item.text_evidence_count !== 0"
              :color="$store.state.textEvidenceColor"
              outlined
              small
          >
            {{ item.text_evidence_count }}
          </v-chip>
          <span v-else>-</span>
        </template>

        <template v-slot:item.figure_evidence_count="{ item }">
          <v-chip
              v-if="item.figure_evidence_count !== 0"
              :color="$store.state.figureEvidenceColor"
              outlined
              small
          >
            {{ item.figure_evidence_count }}
          </v-chip>
          <span v-else>-</span>
        </template>

        <template v-slot:item.experiment_evidence_count="{ item }">
          <v-chip
              v-if="item.experiment_evidence_count !== 0"
              :color="$store.state.experimentEvidenceColor"
              outlined
              small
          >
            {{ item.experiment_evidence_count }}
          </v-chip>
          <span v-else>-</span>
        </template>

        <template v-slot:item.cohort_evidence_count="{ item }">
          <v-chip
              v-if="item.cohort_evidence_count !== 0"
              :color="$store.state.cohortEvidenceColor"
              outlined
              small
          >
            {{ item.cohort_evidence_count }}
          </v-chip>
          <span v-else>-</span>
        </template>
      </v-data-table>
    </v-sheet>
  </v-sheet>
</template>

<script>
import Helpicon from "@/components/sub/helpicon.vue";

export default {
  name: "HomeTable",
  props: ["tdata"],
  components: { Helpicon },
  data() {
    return {
      search: "",
      sortBy: ["id"],
      sortDesc: [false],
      expandedRows: {},
    };
  },
  methods: {

    extractNumber(id) {
      const match = id.match(/(?:[:\-_.])?(\d+)$/);
      return match ? parseInt(match[1], 10) : 0;
    },
    customSort(items, sortBy, sortDesc) {
      const key = sortBy[0];
      const desc = sortDesc[0];

      if (key === "id") {
        return items.slice().sort((a, b) => {
          const numA = this.extractNumber(a.id);
          const numB = this.extractNumber(b.id);
          return (numA - numB) * (desc ? -1 : 1);
        });
      }

      const numericFields = [
        "evidence_total",
        "text_evidence_count",
        "figure_evidence_count",
        "experiment_evidence_count",
        "cohort_evidence_count",
          'publication_score_norm',
          'data_score_norm'
      ];
      if (numericFields.includes(key)) {
        return items.slice().sort((a, b) => {
          const valA = a[key] ?? 0;
          const valB = b[key] ?? 0;
          return (valA - valB) * (desc ? -1 : 1);
        });
      }

      return items;
    },
    handleSortByUpdate(newVal) {
      if (!newVal || newVal.length === 0) {
        this.sortBy = ["id"];
        this.sortDesc = [false];
      } else {
        this.sortBy = newVal;
      }
    },
    isExpanded(key) {
      return this.expandedRows[key] === true;
    },
    toggleExpanded(key) {
      this.$set(this.expandedRows, key, !this.expandedRows[key]);
    }
  },
  computed:{
      dynamicHeaders() {
        const hasUserInput = this.tdata.some(item => item.user_input_score !== null && item.user_input_score !== undefined);
        const baseHeaders = [
          { text: "ID", value: "id", align: "start", sortable: true, width: "9%" },

          {
            text: "GPT Sentence Summary",
            value: "sentence_based_summary",
            align: "start",
            sortable: false,
            width: "40%"
          },
          { text: "Publication Score", value: "publication_score_norm", width: "8%" },
          { text: "Data Score", value: "data_score_norm", width: "7%" },
          { text: "#Total", value: "evidence_total", width: "5%" },
          { text: "#Text mining", value: "text_evidence_count", width: "6%" },
          { text: "#Figure mining", value: "figure_evidence_count", width: "6%" },
          { text: "#PTMAtlas datasets", value: "experiment_evidence_count", width: "8%" },
          { text: "#CPTAC datasets", value: "cohort_evidence_count", width: "8%" },
        ];

        // const baseHeaders = [
        //   { text: "ID", value: "id", align: "start", sortable: true },
        //   { text: "GPT Sentence Summary", value: "sentence_based_summary", align: "start", sortable: false },
        //   // { text: "GPT Knowledge Summary", value: "knowledge_based_summary", align: "start", sortable: false },
        //   { text: "Publication Score", value: "publication_score_norm", align: "start", sortable: true },
        //   { text: "Data Score", value: "data_score_norm", align: "start", sortable: true },
        //   { text: "#Total", value: "evidence_total", align: "start", sortable: true },
        //   { text: "#Text mining", value: "text_evidence_count", align: "start", sortable: true },
        //   { text: "#Figure mining", value: "figure_evidence_count", align: "start", sortable: true },
        //   { text: "#PTMAtlas datasets", value: "experiment_evidence_count", align: "start", sortable: true },
        //   { text: "#CPTAC datasets", value: "cohort_evidence_count", align: "start", sortable: true },
        // ];
        if (hasUserInput) {
          baseHeaders.splice(7, 0, { text: "User Input Score", value: "user_input_score", align: "start", sortable: true });
        }
        return baseHeaders;
      }

  }
};
</script>

<style scoped>
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: black !important;
  font-size: 0.8rem;
  white-space: nowrap;
}
.sticky-table table {
  table-layout: fixed;
  width: 100%;
}

.sticky-table thead tr th:first-of-type {
  position: sticky;
  left: 0;
  background: white;
  z-index: 2;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  max-width: 200px;
  white-space: nowrap;
}

.sticky-table tbody td:first-child {
  position: sticky;
  left: 0;
  background: white;
  z-index: 0;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.summary-col-1 {
  width: 100%;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
}
::v-deep .v-data-table-header th.sortable {
  color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep .v-data-table-header th.sortable .v-data-table-header__icon {
  opacity: 1 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep .v-data-table-header th.sortable span {
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 1 !important;
}

::v-deep .v-data-table-header th.sortable.active,
::v-deep .v-data-table-header th.sortable.active .v-data-table-header__icon,
::v-deep .v-data-table-header th.sortable:hover,
::v-deep .v-data-table-header th.sortable:hover .v-data-table-header__icon {
  color: #000000 !important;
  opacity: 1 !important;
}

</style>